import { Component, Input, OnInit } from '@angular/core';
import { Common } from 'src/app/common';

@Component({
  selector: 'app-manual-summary',
  templateUrl: './manual-summary.component.html',
  styleUrls: ['./manual-summary.component.scss']
})
export class ManualSummaryComponent implements OnInit {
  @Input() summary?: any;

  constructor() { }

  ngOnInit(): void {
  }

  public getPaymentAmount(): string {
    return `${Common.getFormattedCurrencyValue(this.summary?.amount ?? 0, false, false)} ${this.summary?.currency ?? ''}`;
  }
}
